module.exports = __webpack_public_path__ + "static/media/1a_background.17227bae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/backgrounds/1a_background.png
// module id = 2540
// module chunks = 0